import withInputErrorMessage from '../../withInputErrorMessage';
import withOptionsSelectValueInitById from '../withOptionsSelectValueInitById';
import withFormikSelect from '../withSelectFormik';

export const options = [
   {
      value: 'Y',
      label: 'Manual',
      id: 'Y',
      name: 'Manual',
   },
   {
      value: 'N',
      label: 'Automatic',
      id: 'N',
      name: 'Automatic',
   },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
